/*
  Sinal de sessao invalida para o host que embute o painel.

  O dale-vue roda dentro do Dale Desktop num iframe. Quando o token morre, o
  caminho antigo era `window.location.href = '/login'`, o que trocava o
  conteudo do iframe pelo formulario de login - dentro da sidebar, onde o
  usuario nao tem o que fazer: a sessao dele e do aplicativo (#234).

  O host ja sabe reagir a `dale365-auth-invalid`: no desktop ele abre a tela
  de autorizacao, e fora do desktop cai no login web. Aqui so avisamos.
*/

import { LIVE_EMBED_PARENT_ORIGIN } from './liveEmbedBridge.mjs';

export const EMBED_AUTH_INVALID_MESSAGE = Object.freeze({
  type: 'dale365-auth-invalid',
  version: 1,
});

/**
 * Avisa o host de que a sessao morreu.
 *
 * Devolve `true` quando o aviso saiu - e nesse caso quem chamou NAO deve
 * navegar, porque quem decide o proximo passo e o host. Devolve `false`
 * quando nao estamos embutidos, e ai o fluxo normal de logout continua.
 */
export function signalEmbeddedAuthInvalid({
  selfWindow,
  parentWindow,
  targetOrigin = LIVE_EMBED_PARENT_ORIGIN,
} = {}) {
  // Sem pai, ou pai igual a si mesmo, e aba normal: nada a avisar.
  if (!selfWindow || !parentWindow || parentWindow === selfWindow) return false;
  if (typeof parentWindow.postMessage !== 'function') return false;

  try {
    parentWindow.postMessage({ ...EMBED_AUTH_INVALID_MESSAGE }, targetOrigin);
    return true;
  } catch (err) {
    // Host inalcancavel e pior do que nao avisar: sem o aviso e sem
    // navegacao o usuario ficaria olhando uma tela morta. Deixa o
    // chamador seguir com o logout normal.
    console.warn('[embed-auth] nao consegui avisar o host', err);
    return false;
  }
}

/** Atalho para o uso real no navegador. */
export function notifyHostAuthInvalid() {
  if (typeof window === 'undefined') return false;
  return signalEmbeddedAuthInvalid({ selfWindow: window, parentWindow: window.parent });
}
